const comTtl = (() => {
  const comTtls = document.querySelectorAll('.js-com-ttl');
  if (comTtls.length > 0) {



    comTtls.forEach(element => {

      let span = element.querySelectorAll('span');

      gsap.set(span, {
        rotationY: '90deg',
        opacity: "0",
      })

      let to = gsap.to(span, {
        rotationY: '0deg',
        opacity: "1",
        ease: "none",
        scrollTrigger: {
          trigger: element,
          start: "0% 80%",
          // markers: true
        },
        stagger: 0.1,
      })


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          to.scrollTrigger.refresh()
          // console.log('comParallax refresh');
        });
      });
      observer.observe(target);

    });



  }
})();
export default comTtl;